// This module provides API call methods for SDN store API endpoint:
// https://stage-developer.sephora.com/specs/v1/docs/store.html

const olrToken = 'OLR_AUTH_TOKEN';
const bvToken = 'BV_AUTH_TOKEN';
const ufeToken = 'UFE_AUTH_TOKEN';

const { withSdnToken } = require('services/api/sdn/sdnToken');
const addPaymentCreditCard = require('services/api/onlineReservation/addPaymentCreditCard');
const bookReservation = require('services/api/onlineReservation/bookReservation');
const { getEvents } = require('services/api/happening/getEvents');
const { getServicesAndEvents } = require('services/api/happening/getServicesAndEvents');
const cancelReservation = require('services/api/onlineReservation/cancelReservation');
const createReservation = require('services/api/onlineReservation/createReservation');
const deletePaymentCreditCard = require('services/api/onlineReservation/deletePaymentCreditCard');
const getExperiences = require('services/api/onlineReservation/getExperiences');
const getPoliciesPerActivity = require('services/api/onlineReservation/getPoliciesPerActivity');
const getPaymentOptions = require('services/api/onlineReservation/getPaymentOptions');
const getReservationByConfNumber = require('services/api/onlineReservation/getReservationByConfNumber');
const getReservations = require('services/api/onlineReservation/getReservations');
const updatePaymentCreditCard = require('services/api/onlineReservation/updatePaymentCreditCard');
const updateReservation = require('services/api/onlineReservation/updateReservation');

const getBrandsList = require('services/api/reverseLookUp/getBrandsList');
const getProductIdLab = require('services/api/reverseLookUp/getProductIdLab');
const getProductList = require('services/api/reverseLookUp/getProductList');
const getProductSkuList = require('services/api/reverseLookUp/getProductSkuList');
const getReverseLookUpSkuDetails = require('services/api/reverseLookUp/getReverseLookUpSkuDetails');
const getMultiMatch = require('services/api/reverseLookUp/getMultiMatch');
const getLABCodeDescription = require('services/api/reverseLookUp/getLABCodeDescription');
const notificationsApi = require('services/api/notifications');
const getFulfillmentOptions = require('services/api/upfunnel/getFulfillmentOptions');
const { gameOptIn } = require('services/api/gamification/gameOptIn');
const { acknowledgeGameCompletion } = require('services/api/gamification/acknowledgeGameCompletion');
const { challengeMessage } = require('services/api/gamification/challengeMessage');
const checkin = require('services/api/reservations/checkin');

module.exports = {
    addPaymentCreditCard,
    getEvents: withSdnToken(getEvents, ufeToken),
    getServicesAndEvents: withSdnToken(getServicesAndEvents, ufeToken),
    bookReservation: withSdnToken(bookReservation, olrToken),
    cancelReservation: withSdnToken(cancelReservation, olrToken),
    createReservation: withSdnToken(createReservation, olrToken),
    deletePaymentCreditCard,
    getExperiences: withSdnToken(getExperiences, olrToken),
    getPoliciesPerActivity: withSdnToken(getPoliciesPerActivity, olrToken),
    getPaymentOptions,
    getReservationByConfNumber: withSdnToken(getReservationByConfNumber, olrToken),
    getReservations: withSdnToken(getReservations, olrToken),
    updatePaymentCreditCard,
    updateReservation: withSdnToken(updateReservation, olrToken),

    getBrandsList: withSdnToken(getBrandsList, bvToken),
    getProductIdLab: withSdnToken(getProductIdLab, bvToken),
    getProductList: withSdnToken(getProductList, bvToken),
    getProductSkuList: withSdnToken(getProductSkuList, bvToken),
    getMultiMatch: withSdnToken(getMultiMatch, bvToken),
    getLABCodeDescription: withSdnToken(getLABCodeDescription, bvToken),
    getReverseLookUpSkuDetails,
    getFulfillmentOptions,
    gameOptIn: withSdnToken(gameOptIn, ufeToken),
    acknowledgeGameCompletion: withSdnToken(acknowledgeGameCompletion, ufeToken),
    challengeMessage: withSdnToken(challengeMessage, ufeToken),
    // Notification service
    notifyCurbsidePickup: withSdnToken(notificationsApi.curbsidePickupCheckin, ufeToken),
    // Reservation service
    checkin: withSdnToken(checkin, olrToken)
};
